import getAvailableArvatoOptions from '../../../actions/paymentActions/arvato/getAvailableArvatoOptions';
import {getSelectedPaymentOptionType} from '../../selectors';

export default () => (dispatch, getState) => {
  if (getSelectedPaymentOptionType(getState()).toLowerCase() === 'arvato') {
    dispatch(getAvailableArvatoOptions());
  }
};
